<div class="remove-list-dialog">
  <div class="remove-list-dialog__question">
    Willst du deine Merkliste wirklich löschen? Deine gespeicherten Einträge können dann nicht mehr hergestellt werden.
  </div>

  <div class="remove-list-dialog__actions">
    <div class="remove-list-dialog__action" (click)="onClosed.emit(true);">
      <brt-button [title]="'Abbrechen'" color="transparent"></brt-button>
    </div>
    <div class="remove-list-dialog__action" (click)="confirm()">
      <brt-button [title]="'Endgültig löschen'" color="river"></brt-button>
    </div>
  </div>
</div>
